export const getExtranetPermissionByPlace = (myPermission, placeId) => {
  if (!Array.isArray(myPermission) || !myPermission.length) {
    return null;
  }

  if (placeId) {
    const matched = myPermission.find((item) => {
      const itemPlaceId = item?.place?._id;

      return itemPlaceId === placeId;
    });

    if (matched?.permission) {
      return matched.permission;
    }
  }

  return myPermission[0]?.permission ?? null;
};

export const hasExtranetNavPermission = (permission, permissionKey) => {
  if (!permissionKey) {
    return true;
  }

  if (!permission) {
    return false;
  }

  if (permissionKey === 'booking') {
    const { booking } = permission;

    if (!booking) {
      return false;
    }

    if (typeof booking === 'boolean') {
      return booking;
    }

    return Object.values(booking).some(Boolean);
  }

  return !!permission[permissionKey];
};

export const filterExtranetNavigation = (navigation, permission) => navigation.filter(
  (item) => hasExtranetNavPermission(permission, item.permissionKey),
);
